import { Input } from '@shared/components/ui/input'
import { Label } from '@shared/components/ui/label'
import { useEffect, useState } from 'react'
import { hslToHex, parseHexColor } from '../lib/colors'

interface HexColorFieldProps {
  id: string
  label: string
  description?: string
  // Cor no formato interno "H S% L%"; a pessoa vê e digita só o código #RRGGBB.
  value: string
  onChange: (value: string) => void
}

export function HexColorField({ id, label, description, value, onChange }: HexColorFieldProps) {
  const hex = hslToHex(value)
  const [text, setText] = useState(hex)
  const [invalid, setInvalid] = useState(false)

  useEffect(() => {
    setText(hex)
    setInvalid(false)
  }, [hex])

  const commit = (next: string) => {
    setText(next)
    const parsed = parseHexColor(next)
    setInvalid(next.trim() !== '' && parsed === null && next.replace('#', '').length >= 6)
    if (parsed !== null) onChange(parsed)
  }

  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
      <div className="flex items-center gap-3">
        <input
          type="color"
          aria-label={`Escolher: ${label}`}
          value={hex}
          onChange={(event) => onChange(parseHexColor(event.target.value) ?? value)}
          className="h-11 w-14 shrink-0 cursor-pointer rounded-lg border bg-transparent p-1"
        />
        <Input
          id={id}
          value={text}
          onChange={(event) => commit(event.target.value)}
          onBlur={() => {
            if (parseHexColor(text) === null) {
              setText(hex)
              setInvalid(false)
            }
          }}
          inputMode="text"
          autoCapitalize="characters"
          spellCheck={false}
          maxLength={7}
          placeholder="#0E7490"
          aria-invalid={invalid}
          aria-describedby={invalid ? `${id}-erro` : undefined}
          className="font-mono uppercase"
        />
      </div>
      {invalid ? (
        <p id={`${id}-erro`} className="text-sm text-red-600 dark:text-red-300">
          Use 6 letras ou números, como #0E7490.
        </p>
      ) : null}
    </div>
  )
}
